import React, { createContext, useState, } from 'react';
export var OrderContext = createContext({
    currentBopisOosDrawer: '',
    setCurrentBopisOosDrawer: function () { return null; },
    showDrawerError: null,
    setShowDrawerError: function () { return null; },
    showExcludedShipStateApiError: {},
    setExcludedShipStateApiError: function () { return null; },
    showReasonCodesApiError: {},
    setReasonCodesApiError: function () { return null; },
    cancellationReasonCodes: [],
    setCancellationReasonCodes: function () { return null; },
    orderDetailsData: {},
    setOrderDetailsData: function () { return null; },
    orderId: '',
    setOrderId: function () { return undefined; },
    customerType: undefined,
    setCustomerType: function () { return undefined; },
    showDeliveryAvailableSlotsApiError: {},
    setDeliveryAvailableSlotsApiError: function () { return undefined; },
    showDeliveryAddressesApiError: {},
    setDeliveryAddressesApiError: function () { return undefined; },
    fulfillmentOptionsResponse: null,
    setFulfillmentOptionsResponse: function () { return null; },
});
export var OrderProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), currentBopisOosDrawer = _b[0], setCurrentBopisOosDrawer = _b[1];
    var _c = useState(null), showDrawerError = _c[0], setShowDrawerError = _c[1];
    var _d = useState({}), showExcludedShipStateApiError = _d[0], setExcludedShipStateApiError = _d[1];
    var _e = useState({}), showReasonCodesApiError = _e[0], setReasonCodesApiError = _e[1];
    var _f = useState([]), cancellationReasonCodes = _f[0], setCancellationReasonCodes = _f[1];
    var _g = useState({}), showDeliveryAvailableSlotsApiError = _g[0], setDeliveryAvailableSlotsApiError = _g[1];
    var _h = useState({}), orderDetailsData = _h[0], setOrderDetailsData = _h[1];
    var _j = useState(undefined), orderId = _j[0], setOrderId = _j[1];
    var _k = useState(undefined), customerType = _k[0], setCustomerType = _k[1];
    var _l = useState({}), showDeliveryAddressesApiError = _l[0], setDeliveryAddressesApiError = _l[1];
    var _m = useState(null), fulfillmentOptionsResponse = _m[0], setFulfillmentOptionsResponse = _m[1];
    return (React.createElement(OrderContext.Provider, { value: {
            currentBopisOosDrawer: currentBopisOosDrawer,
            setCurrentBopisOosDrawer: setCurrentBopisOosDrawer,
            showDrawerError: showDrawerError,
            setShowDrawerError: setShowDrawerError,
            showExcludedShipStateApiError: showExcludedShipStateApiError,
            setExcludedShipStateApiError: setExcludedShipStateApiError,
            showReasonCodesApiError: showReasonCodesApiError,
            setReasonCodesApiError: setReasonCodesApiError,
            cancellationReasonCodes: cancellationReasonCodes,
            setCancellationReasonCodes: setCancellationReasonCodes,
            orderDetailsData: orderDetailsData,
            setOrderDetailsData: setOrderDetailsData,
            orderId: orderId,
            setOrderId: setOrderId,
            customerType: customerType,
            setCustomerType: setCustomerType,
            showDeliveryAvailableSlotsApiError: showDeliveryAvailableSlotsApiError,
            setDeliveryAvailableSlotsApiError: setDeliveryAvailableSlotsApiError,
            showDeliveryAddressesApiError: showDeliveryAddressesApiError,
            setDeliveryAddressesApiError: setDeliveryAddressesApiError,
            fulfillmentOptionsResponse: fulfillmentOptionsResponse,
            setFulfillmentOptionsResponse: setFulfillmentOptionsResponse,
        } }, children));
};
